import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconTick48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="tick">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M40.7071 12.7071L18 35.4142L7.29285 24.7071L8.70706 23.2928L18 32.5857L39.2928 11.2928L40.7071 12.7071Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconTick24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="tick">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.7071 6.70706L8.99995 18.4142L3.29285 12.7071L4.70706 11.2928L8.99995 15.5857L19.2928 5.29285L20.7071 6.70706Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconTick16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="tick">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.7071 4.70706L5.99995 13.4142L1.29285 8.70706L2.70706 7.29285L5.99995 10.5857L13.2928 3.29285L14.7071 4.70706Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
